import './manageDicts.scss'
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import FormField from "../../../../components/formField/formField";
import DatepickerField from '../../../../components/datepickerField/datepickerField';
import { getDictionaryForEditing } from "../../../../helpers/dictionariesFromLayers";
import { Option, SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { apiContext } from "../../../../contexts/apiContext";
import { prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import { checkIfEdited } from "../../../../helpers/mutableDictionaries";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import { AddEditDictProps, MutableDict } from "./types/manageDictsProps";
import { useContext, useEffect, useState } from "react";
import { DatepickerFieldProps } from '../../../../components/datepickerField/types/datepickerFieldProps';

const EditDict = (props: AddEditDictProps) => {
    const api = useContext(apiContext); 
    const [dictOptions, setDictOptions] = useState<Option[]>([]);   
    const [criterionDictOptions, setCriterionDictOptions] = useState<Option[]>([]); 
    const [selectedDictRec, setSelectedDictRec] = useState<MutableDict | undefined>();
    const [disableInputs, setDisableInputs] = useState<boolean>(false);
    const [inputReload, setInputReload] = useState<boolean>(false);
    
    const dictsWithCustomFields = ["DICT_KRYT_WYZN_TZ_SZCZEGOLOWE"]
    
    // Dict records select
    // Custom dicts selects
    useEffect(() => { 
        if (props.editedDict?.length === 0) { getDictionary(props.dictDefinition[1], setDictOptions, false); } 
        else if (props.editedDict) { prepareDictOptions(props.editedDict, setDictOptions); }

        if (dictsWithCustomFields.includes(props.dictDefinition[0])) { getCustomDictionaries(); }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getDictionary = (layerId: string, setVariable: any, isCustom: boolean) => {
        props.setLoading(true);
        props.setDisableSaveBtn(true);
        props.setDisableDeleteBtn(true);

        getDictionaryForEditing(api.featureServices.dictionariesForEditingBaseUrl + layerId)
        .then((res: any) => {
            if (!isCustom && props.setEditedDict) props.setEditedDict(res);
            prepareDictOptions(res, setVariable);
            props.setLoading(false);
        })
    }

    const getCustomDictionaries = () => {
        switch (props.dictDefinition[0]) 
        {
            case "DICT_KRYT_WYZN_TZ_SZCZEGOLOWE":
                var layer = api.featureServices.dictionariesForEditing.find(item => item[0] === "DICT_KRYT_WYZN_TZ_GLOWNE");
                getDictionary(layer![1], setCriterionDictOptions, true);
                break;
        }       
    }

    const prepareDictOptions = (data: MutableDict[], setVariable: any) => {
        var dictOptions: Option[] = [];
        data.sort((a, b) => a.KOLEJNOSC! - b.KOLEJNOSC!);
        data.forEach(item => {
            var dictOption: Option = { name: item.WARTOSC, value: item.ID};
            dictOptions.push(dictOption);
        })
        setVariable(dictOptions);
    }

    const onChangeSelectDictRecord = (opt: Option[]) => {
        if (opt.length > 0 && props.editedDict) {
            var selectedOption = props.editedDict.find(item => item.ID === opt[0].value);
            setSelectedDictRec(selectedOption!);
            if (selectedOption?.WAZNY_DO) {
                setDisableInputs(true);
                setInputReload(!inputReload);
            }
            else {
                setDisableInputs(false);
                setInputReload(!inputReload);
            }
        }
        else {
            setSelectedDictRec(undefined);
            setDisableInputs(false);
            setInputReload(!inputReload);
        }
    }
    
    const getSelectProps = (label: string, options: Option[], onChange: Function, inputId?: string, style?: React.CSSProperties, selectedSingleOption?: Option[]): SelectInputProps => {
        return {
            label: label,
            hasInputTags: true,
            options: options,
            onlySingleTag: true,
            onChange: inputId ? (event:any) => onChange(event, inputId) : onChange,
            pristine: true,
            className: "selectDictRecord",
            style: style,
            selectedOptions: selectedSingleOption,
        }
    }

    // Action buttons disable toggle
    // Selected record overwrite
    useEffect(() => { 
        props.setEditedDictRecord(selectedDictRec);
        props.setDisableSaveBtn(selectedDictRec === undefined || selectedDictRec.WARTOSC === "" || !checkIfEdited(selectedDictRec, props.editedDict!));
        props.setDisableDeleteBtn(selectedDictRec === undefined || selectedDictRec.WAZNY_DO);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDictRec])

    // Inputs
    const onChangeInput = (event: string, id: string) => {
        setSelectedDictRec((prevData: any) => ({...prevData, [id]: event}));
    }

    const getInputProps =(label: string, placeholder: string, value: any, type: string, inputId: string): FormFieldProps => {
        return {
            labelName: label,
            inputPlaceholder: placeholder,
            value: value,
            type: type,
            pristine: true,
            keepPristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
            disabled: disableInputs,
            reload: inputReload
        }
    }

    // Datepicker
    const onChangeDate = (event: Date, id: string) => {
        props.setEditedDictRecord((prevData: any) => ({...prevData, [id]: event ? event.getTime() : null}));
    }

    const datepickerFieldPropsValidityDate = (label: string, value: any, inputId: string): DatepickerFieldProps => {
        return {
            dateFormat: "yyyy-MM-dd",
            selected: value,
            shouldCloseOnSelect: false,
            fixedHeight: true,       
            labelName: label,
            additionalIcon: eventIcon,
            setValue: (event: any) => onChangeDate(event, inputId),
            pristine: true,
            keepPristine: true,
            disabled: true,
            datepickerSharedProps: {
                className: "readonlyDatepicker"
            },
            className: "readonlyDatepickerWrapper"
        }
    }

    // Custom fields
    const renderCustomFields = () => {
        switch (props.dictDefinition[0]) 
        {
            case "DICT_KRYT_WYZN_TZ_SZCZEGOLOWE":
                var selectedCriterion = prepareDataSingleForSelect(criterionDictOptions, undefined, selectedDictRec?.KRYT_WYZN_TZ_GLOWNE_ID);
                   
                return (
                    <div style={{ paddingTop: "30px"}}>
                        <SelectInput {...getSelectProps(
                            "Główne kryterium wyznaczenia terenu", 
                            criterionDictOptions, 
                            onChangeSelectCustomCriterion, 
                            "KRYT_WYZN_TZ_GLOWNE_ID", 
                            styleFormFieldHalf,
                            selectedCriterion)}/>
                    </div>
                )
        }
    }

    const onChangeSelectCustomCriterion = (opt: Option[], id: string) => {
        if (opt.length > 0) {
            setSelectedDictRec((prevData: any) => ({...prevData, [id]: opt[0].value}))
        }
        else {
            setSelectedDictRec((prevData: any) => ({...prevData, [id]: undefined}))
        } 
    }
    
    return (
        <div className="editDictWrapper">
            <SelectInput {...getSelectProps("Wyszukaj wartość", dictOptions, onChangeSelectDictRecord)} />
            {selectedDictRec !== undefined && 
            <>
                <div className="editDictDetailsInputs">
                    <div>
                        <FormField {...getInputProps(
                            "Wartość",
                            "Wpisz wartość pozycji słownikowej",
                            selectedDictRec.WARTOSC,
                            "text",
                            "WARTOSC"
                        )}/>
                        <FormField {...getInputProps(
                            "Wartość ENG",
                            "Wpisz wartość ENG pozycji słownikowej",
                            selectedDictRec.WARTOSC_EN,
                            "text",
                            "WARTOSC_EN"
                        )}/>
                    </div>
                    <div>
                        <DatepickerField {...datepickerFieldPropsValidityDate(
                            "Ważna do",
                            selectedDictRec.WAZNY_DO, 
                            "WAZNY_DO")}/>
                        
                    </div>               
                </div>
                {renderCustomFields()}
            </>
            }      
        </div>
    );
}

export default EditDict;